import { BASE_URL } from "../utils/BaseUrl";
import httpRequest from "../utils/httpsRequest";

export const Complaints = async (payload) => {
    return await httpRequest(`${BASE_URL}/Agents`, "patch", payload );
  }
  
  export const ComplaintID = async (payload) => {
    return await httpRequest(`${BASE_URL}/Compliant/${payload}`, "get" );
  }